import { Pipe, PipeTransform, inject } from '@angular/core';
import { ActionButtonVariantCssProviderService } from '../providers/action-button-variant-css-provider.service';
import { ActionButtonVariant } from '../enums/action-button-variant';

@Pipe({
  name: 'actionButtonVariantCss',
  standalone: true,
})
export class ActionButtonVariantCssPipe implements PipeTransform {
  private readonly provider = inject(ActionButtonVariantCssProviderService);

  public transform(variant: ActionButtonVariant): string {
    return this.provider.getCss(variant);
  }
}
